import HelloIntroBox from './HelloIntroBox'

export default HelloIntroBox
